import { Pipe, PipeTransform } from '@angular/core';
import { PoContainderSkuDetail } from 'src/app/models/data/po-relate.model';

@Pipe({
  name: 'calculateContainerLoadTotal'
})
export class CalculateContainerLoadTotalPipe implements PipeTransform {

  transform(value: PoContainderSkuDetail[]): number {
    const result = value.reduce((total, b) => total + b.fcl, 0)
    return result;
  }

}
